import SwipeController from "./swipe_controller"

export default class extends SwipeController {
    static targets = ["container", "slide"]

    next() {
        this.indexValue = (this.indexValue + 1) % this.totalSlides
    }

    previous() {
        this.indexValue = (this.indexValue - 1 + this.totalSlides) % this.totalSlides
    }

    // private

    indexValueChanged() {
        const offset = this.indexValue * -100

        this.containerTarget.style.transform = `translateX(${offset}%)`
    }

    get totalSlides() {
        return this.slideTargets.length
    }
}
